<template>
  <answer-template
    :answer-type="'text'"
    :input-data="inputData"
    :index="index"
    :wrapper-class="'any-text-answer'"
    @deleted="$emit('deleted')"
  >
    <template v-slot:label>
      Send any of these message(s)
    </template>
    <template v-slot:content>
      <div v-for="(str,index) in inputData.text" :key="uid+'-'+index">
        <!--<div v-if="index > 0" align="center">or</div>-->
        <div class="field is-grouped">
          <div class="control is-expanded">
            <textarea-autosize
              v-model="inputData.text[index]"
              :placeholder="index>0?'Or another response':'Enter a response.'"
              rows="1"
              class="textarea is-small"
              :min-height="30"
              :max-height="250"
              @keyup.native="onTextChange"
            ></textarea-autosize>
          </div>
          <div class="control">
            <button
              class="button is-inverted is-danger is-small"
              @click="removeResponse(index)">
                <span class="icon">
                  <font-awesome-icon icon="trash"></font-awesome-icon>
                </span>
            </button>
          </div>
        </div>
      </div>
      <div align="center" class="add-response">
        <button class="button is-rounded is-small" @click="addResponse">
              <span class="icon">
                <font-awesome-icon icon="plus"></font-awesome-icon>
              </span>
          <span>Response</span>
        </button>
      </div>
    </template>
  </answer-template>
</template>
<script>
import AnswerTemplate from './AnswerTemplate.vue';

export default {
  name: 'anyTextAnswer',
  components: {
    AnswerTemplate,
  },
  props: {
    inputData: {
      type: Object,
      default() {
        return {
          type: 'send_any_message',
          text: [],
        };
      },
    },
    index: {
      type: Number,
    },
    uid: {
      type: String,
    },
  },
  data() {
    return {};
  },
  methods: {
    addResponse() {
      this.inputData.text.push('');
      this.toggleDirty();
    },
    removeResponse(index) {
      this.inputData.text.splice(index, 1);
      this.toggleDirty();
    },
    toggleDirty() {
      this.$emit('dirty');
    },
    onTextChange() {
      this.toggleDirty();
    },
    removeBlock() {
      this.$buefy.dialog.confirm({
        title: 'Removing text block',
        message: 'Are you sure to remove this text block?',
        cancelText: 'Cancel',
        confirmText: 'Remove',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.$emit('deleted');
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
  .any-text-answer {
  }
</style>
